import { home } from "../strings";

/** Phone Home copy. Shared Home strings are reused so a wording fix lands once. */
export const mhome = {
  ...home,
  summaryLabel: "Today at a glance",
  seg: { label: "Work", followups: "Follow-ups", appts: "Appts", tasks: "Tasks" },
  metrics: { ...home.metrics, title: "Today so far", sub: (date: string, prev: string) => `${date} · compared with ${prev}`, dotsLabel: "Metric", target: "Monthly target" },
  swipe: { done: "Done", snooze: "Snooze", hint: "Swipe right to finish, left to snooze to tomorrow", doneToast: (n: string) => `${n} marked done`, snoozeToast: (n: string) => `${n} snoozed to tomorrow`, undo: "Undo", saved: "Saved" },
  sheet: { followup: "Follow-up", close: "Close" },
  more: { renewals: "Renewals", schedule: "Today's classes", collections: "Collections" },
} as const;
